import { render, staticRenderFns } from "./dr-simple-layout.vue?vue&type=template&id=66e06d96&"
import script from "./dr-simple-layout.vue?vue&type=script&lang=js&"
export * from "./dr-simple-layout.vue?vue&type=script&lang=js&"
import style0 from "./dr-simple-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports